"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PreRegisterResponseDTO = void 0;
class PreRegisterResponseDTO {
    constructor(customer_tax_id, status, message) {
        this.customer_tax_id = customer_tax_id;
        this.status = status;
        this.message = message;
    }
}
exports.PreRegisterResponseDTO = PreRegisterResponseDTO;
//# sourceMappingURL=pre-register-response-dto.js.map